import React, {Component} from 'react';
import styles from './My-Report.module.scss';
import { Row, Container, Col } from 'react-bootstrap';
import UserProfileHeader from '../User-Profile-Header/User-Profile-Header';
import UserProfileSidebar from '../User-Profile-Sidebar/User-Profile-Sidebar';
import MyReportListComponent from './My-Report-List/My-Report-List';
import { DotLoader } from 'react-spinners';
import AuthService from '../../../services/Auth-Service';

class MyReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            myTests: []
        }
    }

    componentDidMount() {
        const API = AuthService.get('my_report');
        API.then(json => {
            this.setState({
                isLoading: true,
                myTests: json.result
            });
        });
        document.title = "My Report"
    }

    render() {
        var {isLoading, myTests} = this.state;
        return(
            <div className="content">

                <UserProfileHeader />

                <Container fluid>
                    <Container>
                        <Row className={`position-relative`}>

                            <Col lg={2} md={3} xs={12} className={`px-0`}>
                                <UserProfileSidebar />
                            </Col>

                            <Col lg={10} md={9} xs={12} className={`customSecondHeading ${styles.userDetailMain}`}>
                                <h5>
                                    My Report
                                    <span>
                                        Report List
                                    </span>
                                </h5>

                                <Row className={`mt-5`}>

                                    <Col xs={12} className={`tableMainDiv`}>
                                    {
                                        isLoading ? (<MyReportListComponent myTests={myTests}/>) : 
                                        (<div className={`sweet-loading customLoader`}>
                                            <DotLoader
                                                color={'#ef3c67'}
                                                loading={this.state.loading}  
                                            />
                                        </div>)
                                    }
                                    </Col>
                                    
                                </Row>

                            </Col>
                            
                        </Row>
                    </Container>
                </Container>

            </div>
        );
    }
}

export default MyReport;